// @ts-nocheck
import { useTranslation } from "react-i18next";
import { Fields } from "./types/types";

export const useTranslateFields = (fields: Fields) => {
  const { t } = useTranslation();

  return Object.keys(fields).reduce((acc, key) => {
    const field = fields[key];

    if (field.type === "dropdown") {
      field.options = field.options?.map((option: any) => {
        return t(option);
      });
    }

    acc[key] = {
      ...field,
      label: t(field.label),
      placeholder: t(field.placeholder),
      checkboxLabel: t(field.checkboxLabel),
      rules: {
        ...field.rules,
        required: t(field.rules?.required!) ?? "",
        pattern: {
          ...field.rules?.pattern,
          message: t(field.rules?.pattern?.message!) ?? "",
        },
      },
    };
    return acc;
  }, {});
};
